import React from 'react'
import UserDetails from './userDetails'

const Createmembership = () => {
  return (
    <div>
        <UserDetails />
    </div>
  )
}

export default Createmembership